import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
// CORRECCIÓN: Se agregó FaUtensils a la lista de imports + FaTrash y FaUndo para eliminación
import {
    FaArrowLeft, FaPrint, FaEye, FaLock, FaCheckCircle,
    FaMoneyBillWave, FaCashRegister, FaChartLine, FaCalendarAlt,
    FaTimes, FaReceipt, FaClock, FaUser, FaUtensils, FaDollarSign, FaFileAlt,
    FaTrash, FaUndo, FaHistory
} from 'react-icons/fa';

const API_URL = 'https://api.alquilacarbolivia.com/api';

// Helper para formatear fechas en zona horaria de Bolivia
const formatBoliviaDate = (dateString) => {
    const date = new Date(dateString);
    const formatter = new Intl.DateTimeFormat('es-BO', {
        timeZone: 'America/La_Paz',
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
    });
    return formatter.format(date);
};

const formatBoliviaTime = (dateString) => {
    const date = new Date(dateString);
    const formatter = new Intl.DateTimeFormat('es-BO', {
        timeZone: 'America/La_Paz',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true
    });
    return formatter.format(date);
};

const formatBoliviaDateTime = (dateString) => {
    const date = new Date(dateString);
    const formatter = new Intl.DateTimeFormat('es-BO', {
        timeZone: 'America/La_Paz',
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true
    });
    return formatter.format(date);
};

export default function MisVentas({ sucursalId, user, goBack }) {
    const [turnos, setTurnos] = useState([]);
    const [loading, setLoading] = useState(true);
    const [ventasTurno, setVentasTurno] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [turnoSeleccionado, setTurnoSeleccionado] = useState(null);
    const [filtroEstado, setFiltroEstado] = useState('todos'); // todos, abiertos, cerrados
    const mesActualBO = new Date().toLocaleDateString('en-CA', { timeZone: 'America/La_Paz' }).slice(0, 7);
    const [mesSel, setMesSel] = useState(mesActualBO);
    const [limite, setLimite] = useState(25);
    const [egresosAll, setEgresosAll] = useState(null); // null = cargando, false = error
    useEffect(() => { setLimite(25); }, [mesSel, filtroEstado]);

    useEffect(() => {
        let activo = true;
        axios.get(`${API_URL}/egresos/${sucursalId}`)
            .then(res => { if (activo) setEgresosAll(res.data); })
            .catch(err => { console.error('Error al cargar egresos:', err); if (activo) setEgresosAll(false); });
        return () => { activo = false; };
    }, [sucursalId]);
    
    // Estados para eliminación
    const [tabActual, setTabActual] = useState('turnos'); // 'turnos' o 'eliminadas'
    const [ventasEliminadas, setVentasEliminadas] = useState([]);
    const [showModalEliminar, setShowModalEliminar] = useState(false);
    const [ventaAEliminar, setVentaAEliminar] = useState(null);
    const [pinEliminar, setPinEliminar] = useState('');
    const [motivoEliminar, setMotivoEliminar] = useState('');

    // Estados para edición de ingredientes
    const [showModalEditar, setShowModalEditar] = useState(false);

    // Estados para cambiar el metodo de pago
    const [showModalMetodo, setShowModalMetodo] = useState(false);
    const [ventaMetodo, setVentaMetodo] = useState(null);
    const [nuevoMetodo, setNuevoMetodo] = useState('efectivo');
    const [montoE, setMontoE] = useState('');
    const [montoQ, setMontoQ] = useState('');
    const [pinMetodo, setPinMetodo] = useState('');
    const [guardandoMetodo, setGuardandoMetodo] = useState(false);
    const [ventaEditando, setVentaEditando] = useState(null);
    const [productosEditando, setProductosEditando] = useState([]); // copia editable de v.productos
    const [recetasCache, setRecetasCache] = useState({}); // { nombreProducto: [{insumo_id, nombre_insumo, cantidad_requerida}] }

    useEffect(() => {
        fetchHistorial();
        if (tabActual === 'eliminadas') {
            cargarVentasEliminadas();
        }
    }, [sucursalId, tabActual, mesSel]);

    const fetchHistorial = async () => {
        try {
            const res = await axios.get(`${API_URL}/caja/historial/${sucursalId}`, { params: { mes: mesSel } });
            setTurnos(res.data);
            setLoading(false);
        } catch (error) {
            console.error(error);
            setLoading(false);
        }
    };

    // Cargar ventas eliminadas
    const cargarVentasEliminadas = async () => {
        try {
            const res = await axios.get(`${API_URL}/ventas-eliminadas/${sucursalId}`);
            setVentasEliminadas(res.data);
        } catch (error) {
            console.error('Error al cargar ventas eliminadas:', error);
        }
    };

    // ---------- CAMBIAR METODO DE PAGO ----------
    const abrirMetodo = (venta) => {
        const m = String(venta.metodo_pago || '').toLowerCase();
        const mE = m.match(/e:?(\d+\.?\d*)/i);
        const mQ = m.match(/q:?(\d+\.?\d*)/i);
        setVentaMetodo(venta);
        setNuevoMetodo(m.includes('mixto') ? 'mixto' : (m.includes('qr') ? 'qr' : 'efectivo'));
        setMontoE(m.includes('mixto') && mE ? mE[1] : '');
        setMontoQ(m.includes('mixto') && mQ ? mQ[1] : '');
        setPinMetodo('');
        setShowModalMetodo(true);
    };

    const cambiarMonto = (campo, valor) => {
        const total = parseFloat(ventaMetodo.total);
        const v = parseFloat(valor);
        const resto = isNaN(v) ? '' : String(Math.round((total - v) * 100) / 100);
        if (campo === 'e') { setMontoE(valor); setMontoQ(resto); }
        else { setMontoQ(valor); setMontoE(resto); }
    };

    const guardarMetodo = async () => {
        if (guardandoMetodo) return;
        const total = parseFloat(ventaMetodo.total);
        if (nuevoMetodo === 'mixto') {
            const e = parseFloat(montoE);
            const q = parseFloat(montoQ);
            if (!(e > 0) || !(q > 0) || Math.abs(e + q - total) > 0.01) {
                Swal.fire('Atención', `Efectivo y QR deben ser mayores a 0 y sumar Bs. ${total.toFixed(2)}`, 'warning');
                return;
            }
        }
        if (!pinMetodo) {
            Swal.fire('Atención', 'Ingresa el PIN de seguridad', 'warning');
            return;
        }
        setGuardandoMetodo(true);
        try {
            await axios.put(`${API_URL}/ventas/${ventaMetodo.id}/metodo-pago`, {
                metodo: nuevoMetodo,
                monto_efectivo: montoE,
                monto_qr: montoQ,
                pin: pinMetodo,
                usuario_id: user?.id
            });
            setShowModalMetodo(false);
            Swal.fire({ icon: 'success', title: 'Método de pago actualizado', timer: 1800, showConfirmButton: false });
            if (turnoSeleccionado) verVentas(turnoSeleccionado);
            fetchHistorial();
        } catch (error) {
            Swal.fire('Error', error.response?.data?.error || 'No se pudo cambiar el método de pago', 'error');
        } finally {
            setGuardandoMetodo(false);
        }
    };

    // Abrir modal de edición de ingredientes
    const handleEditarVenta = async (venta) => {
        try {
            // Clonar productos para editar sin mutar el original
            const productosClon = JSON.parse(JSON.stringify(venta.productos));

            // Precargar recetas necesarias (para milanesas simples y para M1/M2 de mixtas)
            const nuevasRecetas = { ...recetasCache };
            for (const p of productosClon) {
                let parsed = null;
                try {
                    parsed = p.ingredientes_excluidos
                        ? (typeof p.ingredientes_excluidos === 'string' ? JSON.parse(p.ingredientes_excluidos) : p.ingredientes_excluidos)
                        : null;
                } catch (e) { parsed = null; }

                const esMixta = parsed && typeof parsed === 'object' && !Array.isArray(parsed) && (parsed.m1 || parsed.m2);
                p._parsed = parsed;
                p._esMixta = !!esMixta;

                if (esMixta) {
                    for (const nombreMitad of [parsed.m1, parsed.m2]) {
                        if (nombreMitad && !nuevasRecetas[nombreMitad]) {
                            try {
                                const prodRes = await axios.get(`${API_URL}/productos/${sucursalId}`);
                                const prodEncontrado = prodRes.data.find(pr => pr.nombre === nombreMitad);
                                if (prodEncontrado) {
                                    const recRes = await axios.get(`${API_URL}/recetas/${prodEncontrado.id}`);
                                    nuevasRecetas[nombreMitad] = recRes.data;
                                }
                            } catch (e) { console.error('Error cargando receta de', nombreMitad, e); }
                        }
                    }
                } else if (!nuevasRecetas[p.producto_nombre]) {
                    try {
                        const recRes = await axios.get(`${API_URL}/recetas/${p.producto_id}`);
                        nuevasRecetas[p.producto_nombre] = recRes.data;
                    } catch (e) { console.error('Error cargando receta de', p.producto_nombre, e); }
                }
            }

            setRecetasCache(nuevasRecetas);
            setProductosEditando(productosClon);
            setVentaEditando(venta);
            setShowModalEditar(true);
        } catch (error) {
            console.error(error);
            Swal.fire('Error', 'No se pudo cargar la información del producto', 'error');
        }
    };

    // Abrir modal de eliminación
    const handleEliminarVenta = (venta) => {
        setVentaAEliminar(venta);
        setPinEliminar('');
        setMotivoEliminar('');
        setShowModalEliminar(true);
    };

    // Confirmar eliminación con PIN
    const confirmarEliminacion = async () => {
        if (!pinEliminar) {
            Swal.fire('Error', 'Ingrese el PIN de seguridad', 'error');
            return;
        }

        try {
            const res = await axios.post(`${API_URL}/ventas-eliminadas/eliminar`, {
                venta_id: ventaAEliminar.id,
                pin: pinEliminar,
                motivo: motivoEliminar,
                usuario_id: user.id
            });

            Swal.fire({
                icon: 'success',
                title: 'Venta Eliminada',
                text: res.data.message,
                timer: 2000,
                showConfirmButton: false
            });

            setShowModalEliminar(false);
            setVentaAEliminar(null);
            setPinEliminar('');
            setMotivoEliminar('');
            
            // Recargar ventas del turno
            if (turnoSeleccionado) {
                verVentas(turnoSeleccionado);
            }

        } catch (error) {
            Swal.fire('Error', error.response?.data?.error || 'No se pudo eliminar la venta', 'error');
        }
    };

    // Alternar un ingrediente excluido/incluido de un producto en edición (producto normal o milanesa simple)
    const toggleIngredienteSimple = (prodIdx, insumoId) => {
        setProductosEditando(prev => {
            const copia = [...prev];
            const p = { ...copia[prodIdx] };
            let excluidos = Array.isArray(p._parsed) ? [...p._parsed] : [];
            excluidos = excluidos.map(i => parseInt(i));
            if (excluidos.includes(insumoId)) {
                excluidos = excluidos.filter(i => i !== insumoId);
            } else {
                excluidos.push(insumoId);
            }
            p._parsed = excluidos;
            copia[prodIdx] = p;
            return copia;
        });
    };

    // Alternar un ingrediente excluido/incluido de un producto Milanesa Mixta (marca en M1 y/o M2 según corresponda)
    const toggleIngredienteMixta = (prodIdx, insumoId, enM1, enM2) => {
        setProductosEditando(prev => {
            const copia = [...prev];
            const p = { ...copia[prodIdx] };
            const parsed = { ...p._parsed };
            let m1Excluidos = Array.isArray(parsed.m1_excluidos) ? parsed.m1_excluidos.map(i => parseInt(i)) : [];
            let m2Excluidos = Array.isArray(parsed.m2_excluidos) ? parsed.m2_excluidos.map(i => parseInt(i)) : [];
            const estaExcluido = (enM1 && m1Excluidos.includes(insumoId)) || (enM2 && m2Excluidos.includes(insumoId));

            if (estaExcluido) {
                m1Excluidos = m1Excluidos.filter(i => i !== insumoId);
                m2Excluidos = m2Excluidos.filter(i => i !== insumoId);
            } else {
                if (enM1) m1Excluidos.push(insumoId);
                if (enM2) m2Excluidos.push(insumoId);
            }
            parsed.m1_excluidos = m1Excluidos;
            parsed.m2_excluidos = m2Excluidos;
            p._parsed = parsed;
            copia[prodIdx] = p;
            return copia;
        });
    };

    // Actualizar observación de un producto en edición
    const actualizarObservacionEditando = (prodIdx, texto) => {
        setProductosEditando(prev => {
            const copia = [...prev];
            copia[prodIdx] = { ...copia[prodIdx], observacion: texto };
            return copia;
        });
    };

    // Guardar todos los cambios de la venta en edición
    const guardarEdicion = async () => {
        try {
            for (const p of productosEditando) {
                await axios.put(`${API_URL}/ventas/detalle/${p.detalle_id}/editar`, {
                    ingredientes_excluidos: p._parsed,
                    observacion: p.observacion || ''
                });
            }
            Swal.fire({
                icon: 'success',
                title: 'Actualizado',
                text: 'Los productos fueron actualizados y el stock ajustado correctamente',
                timer: 2000,
                showConfirmButton: false
            });
            setShowModalEditar(false);
            setVentaEditando(null);
            setProductosEditando([]);
            if (turnoSeleccionado) {
                verVentas(turnoSeleccionado);
            }
        } catch (error) {
            Swal.fire('Error', error.response?.data?.error || 'No se pudo guardar la edición', 'error');
        }
    };

    // Restaurar venta eliminada
    const handleRestaurarVenta = async (ventaEliminada) => {
        const result = await Swal.fire({
            title: '¿Restaurar esta venta?',
            html: `
                <div class="text-start">
                    <p><strong>Venta ID:</strong> #${ventaEliminada.venta_id}</p>
                    <p><strong>Total:</strong> Bs. ${parseFloat(ventaEliminada.total).toFixed(2)}</p>
                    <p><strong>Cliente:</strong> ${ventaEliminada.cliente_nombre || 'Público General'}</p>
                    <p class="text-muted"><small>Se restaurará al turno #${ventaEliminada.turno_id}</small></p>
                </div>
            `,
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Sí, restaurar',
            cancelButtonText: 'Cancelar',
            confirmButtonColor: '#28a745'
        });

        if (result.isConfirmed) {
            try {
                const res = await axios.post(`${API_URL}/ventas-eliminadas/restaurar`, {
                    venta_eliminada_id: ventaEliminada.id,
                    usuario_id: user.id
                });

                Swal.fire({
                    icon: 'success',
                    title: 'Venta Restaurada',
                    text: res.data.message,
                    timer: 2000,
                    showConfirmButton: false
                });

                cargarVentasEliminadas();
                fetchHistorial();

            } catch (error) {
                Swal.fire('Error', error.response?.data?.error || 'No se pudo restaurar la venta', 'error');
            }
        }
    };

    // --- FUNCIÓN UNIFICADA DE IMPRESIÓN ---
    const handleImpresion = async (tipo, id) => {
        if (!id) return;
        try {
            // tipo puede ser 'recibo', 'comanda' o 'reporte-cierre'
            const ruta = tipo === 'reporte-cierre' ? 'caja/reporte-cierre' : `ventas/${tipo}`;
            const res = await axios.get(`${API_URL}/${ruta}/${id}`);

            if (res.data && res.data.pdfUrl) {
                window.open(`https://api.alquilacarbolivia.com${res.data.pdfUrl}`, '_blank');
            } else {
                Swal.fire('Error', 'No se encontró el archivo PDF', 'error');
            }
        } catch (e) {
            console.error(e);
            Swal.fire('Error', 'No se pudo generar el documento', 'error');
        }
    };

    // --- CIERRE DE CAJA ---
    const handleCerrarTurno = async (turnoData) => {
        const { value: montoReal } = await Swal.fire({
            title: 'Cierre de Caja',
            html: `
                <div class="text-center">
                    <p class="mb-2">Cajero: <strong>${turnoData.usuario}</strong></p>
                    <p class="text-danger mb-3">⚠️ Ingresa el total contado en caja (cierre ciego):</p>
                </div>
            `,
            input: 'number',
            inputPlaceholder: '0.00',
            showCancelButton: true,
            confirmButtonText: 'Cerrar Turno',
            cancelButtonText: 'Cancelar',
            confirmButtonColor: '#dc3545',
            inputAttributes: { min: 0, step: 0.01 }
        });

        if (montoReal !== undefined && montoReal !== null) {
            try {
                // 1. Cerrar en BD
                await axios.post(`${API_URL}/caja/cerrar`, {
                    id: turnoData.id,
                    monto_final: montoReal
                });

                // 2. Imprimir el mismo PDF que en el POS
                handleImpresion('reporte-cierre', turnoData.id);

                fetchHistorial();
                Swal.fire({ icon: 'success', title: 'Caja Cerrada', timer: 1500, showConfirmButton: false });

            } catch (error) {
                Swal.fire('Error', 'No se pudo cerrar la caja', 'error');
            }
        }
    };

    // --- AJUSTAR FALTANTE ---
    const handleAjustarFaltante = async (turnoData, diferencia) => {
        const montoFaltante = Math.abs(diferencia);
        const { value: confirmado } = await Swal.fire({
            title: 'Ajustar Faltante',
            html: `
                <div class="text-center">
                    <p class="text-danger fw-bold mb-3">Faltante: Bs. ${montoFaltante.toFixed(2)}</p>
                    <p>¿Deseas agregar Bs. ${montoFaltante.toFixed(2)} para cuadrar la caja?</p>
                    <p class="text-muted small">Esto actualizará el monto final del turno</p>
                </div>
            `,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Sí, ajustar',
            cancelButtonText: 'Cancelar',
            confirmButtonColor: '#28a745'
        });

        if (confirmado) {
            try {
                await axios.post(`${API_URL}/caja/ajustar-faltante/${turnoData.id}`, {
                    monto_ajuste: montoFaltante
                });

                fetchHistorial();
                Swal.fire({ icon: 'success', title: 'Faltante Ajustado', text: 'El turno ha sido cuadrado correctamente', timer: 2000, showConfirmButton: false });
            } catch (error) {
                Swal.fire('Error', 'No se pudo ajustar el faltante', 'error');
            }
        }
    };

    // Función para descargar detalle del turno en PDF
    const descargarDetalleTurno = (turnoId) => {
        const url = `https://api.alquilacarbolivia.com/api/reportes/turno/${turnoId}/pdf`;
        window.open(url, '_blank');
    };

    // --- VER VENTAS DEL TURNO ---
    const verVentas = async (turno) => {
        setTurnoSeleccionado(turno);
        try {
            const res = await axios.get(`${API_URL}/caja/ventas/${turno.id}`);
            setVentasTurno(res.data);
            setShowModal(true);
        } catch (error) {
            Swal.fire('Error', 'No se pudieron cargar las ventas', 'error');
        }
    };

    // ---- Filtro por mes (hora de Bolivia) ----
    const mesDe = (fecha) => new Date(fecha).toLocaleDateString('en-CA', { timeZone: 'America/La_Paz' }).slice(0, 7);
    const NOMBRES_MES = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
    const [anioSel, mesNum] = mesSel.split('-').map(Number);
    const tituloMes = `${NOMBRES_MES[mesNum - 1]} ${anioSel}`;
    const moverMes = (delta) => {
        const d = new Date(anioSel, mesNum - 1 + delta, 1);
        const nuevo = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
        if (nuevo > mesActualBO) return;
        setMesSel(nuevo);
    };
    const turnosMes = turnos.filter(t => mesDe(t.fecha_apertura) === mesSel);
    const abiertosOtroMes = turnos.filter(t => t.estado === 'abierto' && mesDe(t.fecha_apertura) !== mesSel);
    const ventasMesTotal = turnosMes.reduce((s, t) => s + parseFloat(t.total_ventas || 0), 0);
    const totalEgresosMes = Array.isArray(egresosAll)
        ? egresosAll.filter(e => mesDe(e.fecha) === mesSel).reduce((s, e) => s + parseFloat(e.monto || 0), 0)
        : null;
    const balanceMes = totalEgresosMes === null ? null : ventasMesTotal - totalEgresosMes;

    // --- CÁLCULOS DE ESTADÍSTICAS ---
    const calcularEstadisticas = () => {
        const totalVentas = turnosMes.reduce((sum, t) => sum + parseFloat(t.total_ventas || 0), 0);
        const turnosAbiertos = turnosMes.filter(t => t.estado === 'abierto').length;
        const turnosCerrados = turnosMes.filter(t => t.estado === 'cerrado').length;

        return { totalVentas, turnosAbiertos, turnosCerrados, totalTurnos: turnosMes.length };
    };

    const filtrarTurnos = () => {
        switch(filtroEstado) {
            case 'abiertos': return turnosMes.filter(t => t.estado === 'abierto');
            case 'cerrados': return turnosMes.filter(t => t.estado === 'cerrado');
            default: return turnosMes;
        }
    };

    const stats = calcularEstadisticas();
    const turnosFiltrados = filtrarTurnos();

    if (loading) {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '100vh' }}>
                <div className="spinner-border text-primary" role="status"><span className="visually-hidden">Cargando...</span></div>
            </div>
        );
    }

    return (
        <div className="container-fluid p-0" style={{ backgroundColor: '#f8fafc', minHeight: '100vh' }}>
            {/* Header Mejorado */}
            <div style={{
                background: 'linear-gradient(135deg, #06b6d4 0%, #0891b2 100%)',
                padding: '1.5rem 2rem',
                boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)'
            }}>
                <div className="d-flex align-items-center gap-3">
                    <button
                        className="btn btn-light shadow-sm rounded-circle"
                        onClick={goBack}
                        style={{ width: '40px', height: '40px' }}
                    >
                        <FaArrowLeft/>
                    </button>
                    <div className="text-white">
                        <h3 className="m-0 fw-bold d-flex align-items-center gap-2">
                            <FaCashRegister style={{ fontSize: '1.5rem' }}/>
                            Historial de Turnos
                        </h3>
                        <p className="m-0 opacity-75" style={{ fontSize: '0.9rem' }}>
                            Control de caja y ventas por turno
                        </p>
                    </div>
                </div>
            </div>

            <div className="p-4">
                {/* Tabs de navegación */}
                <ul className="nav nav-pills mb-4" style={{background: '#f8f9fa', padding: '10px', borderRadius: '15px'}}>
                    <li className="nav-item flex-fill">
                        <button 
                            className={`nav-link ${tabActual === 'turnos' ? 'active' : ''} w-100`}
                            style={{
                                borderRadius: '10px',
                                fontWeight: 'bold',
                                background: tabActual === 'turnos' ? 'linear-gradient(135deg, #06b6d4 0%, #0891b2 100%)' : 'transparent',
                                color: tabActual === 'turnos' ? 'white' : '#6c757d',
                                border: 'none'
                            }}
                            onClick={() => setTabActual('turnos')}
                        >
                            <FaCashRegister className="me-2" />
                            Turnos y Ventas
                        </button>
                    </li>
                    <li className="nav-item flex-fill">
                        <button 
                            className={`nav-link ${tabActual === 'eliminadas' ? 'active' : ''} w-100`}
                            style={{
                                borderRadius: '10px',
                                fontWeight: 'bold',
                                background: tabActual === 'eliminadas' ? 'linear-gradient(135deg, #06b6d4 0%, #0891b2 100%)' : 'transparent',
                                color: tabActual === 'eliminadas' ? 'white' : '#6c757d',
                                border: 'none'
                            }}
                            onClick={() => setTabActual('eliminadas')}
                        >
                            <FaHistory className="me-2" />
                            Ventas Eliminadas
                        </button>
                    </li>
                </ul>

                {/* TAB TURNOS */}
                {tabActual === 'turnos' && (
                    <>
                        {/* Tarjetas de estadísticas */}
                        <div className="d-flex align-items-center justify-content-between flex-wrap gap-2 mb-3">
                            <div className="d-flex align-items-center gap-2">
                                <button type="button" className="btn btn-outline-secondary" style={{ borderRadius: '10px' }} onClick={() => moverMes(-1)}>‹</button>
                                <div className="fw-bold text-center" style={{ minWidth: '180px', fontSize: '1.15rem' }}>📅 {tituloMes}</div>
                                <button type="button" className="btn btn-outline-secondary" style={{ borderRadius: '10px' }} disabled={mesSel >= mesActualBO} onClick={() => moverMes(1)}>›</button>
                                {mesSel !== mesActualBO && (
                                    <button type="button" className="btn btn-sm btn-outline-info" style={{ borderRadius: '20px' }} onClick={() => setMesSel(mesActualBO)}>Volver al mes actual</button>
                                )}
                            </div>
                            <small className="text-muted">Las tarjetas y la lista muestran solo este mes</small>
                        </div>
                        {abiertosOtroMes.length > 0 && (
                            <div className="alert alert-warning d-flex align-items-center justify-content-between flex-wrap gap-2 mb-3" style={{ borderRadius: '12px' }}>
                                <span>⚠️ Hay {abiertosOtroMes.length} turno{abiertosOtroMes.length !== 1 ? 's' : ''} abierto{abiertosOtroMes.length !== 1 ? 's' : ''} de otro mes: {abiertosOtroMes.map(t => `#${t.id}`).join(', ')}</span>
                                <button type="button" className="btn btn-sm btn-warning" onClick={() => setMesSel(mesDe(abiertosOtroMes[0].fecha_apertura))}>Ver ese mes</button>
                            </div>
                        )}
                        <div className="row g-3 mb-4">
                            <div className="col-6 col-xl">
                                <div className="card border-0 shadow-sm" style={{ borderRadius: '16px', background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)' }}>
                                    <div className="card-body p-3 text-white">
                                        <p className="m-0 opacity-75 small">Ventas Totales</p>
                                        <h4 className="m-0 fw-bold">Bs. {stats.totalVentas.toFixed(2)}</h4>
                                        <div className="position-absolute top-0 end-0 p-3 opacity-25"><FaMoneyBillWave size={30}/></div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-6 col-xl">
                                <div className="card border-0 shadow-sm" style={{ borderRadius: '16px', background: balanceMes !== null && balanceMes < 0 ? 'linear-gradient(135deg, #ef4444 0%, #b91c1c 100%)' : 'linear-gradient(135deg, #14b8a6 0%, #0f766e 100%)' }}>
                                    <div className="card-body p-3 text-white">
                                        <p className="m-0 opacity-75 small">Balance del mes</p>
                                        <h4 className="m-0 fw-bold">
                                            {balanceMes === null ? (egresosAll === false ? 'No disponible' : '...') : `${balanceMes < 0 ? '- ' : ''}Bs. ${Math.abs(balanceMes).toFixed(2)}`}
                                        </h4>
                                        {balanceMes !== null && (
                                            <div className="opacity-75" style={{ fontSize: '0.72rem' }}>Ventas {ventasMesTotal.toFixed(2)} − Egresos {totalEgresosMes.toFixed(2)}</div>
                                        )}
                                        <div className="position-absolute top-0 end-0 p-3 opacity-25"><FaDollarSign size={30}/></div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-6 col-xl">
                                <div className="card border-0 shadow-sm" style={{ borderRadius: '16px', background: 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)' }}>
                                    <div className="card-body p-3 text-white">
                                        <p className="m-0 opacity-75 small">Total Turnos</p>
                                        <h4 className="m-0 fw-bold">{stats.totalTurnos}</h4>
                                        <div className="position-absolute top-0 end-0 p-3 opacity-25"><FaChartLine size={30}/></div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-6 col-xl">
                                <div className="card border-0 shadow-sm" style={{ borderRadius: '16px', background: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)' }}>
                                    <div className="card-body p-3 text-white">
                                        <p className="m-0 opacity-75 small">Turnos Abiertos</p>
                                        <h4 className="m-0 fw-bold">{stats.turnosAbiertos}</h4>
                                        <div className="position-absolute top-0 end-0 p-3 opacity-25"><FaCheckCircle size={30}/></div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-6 col-xl">
                                <div className="card border-0 shadow-sm" style={{ borderRadius: '16px', background: 'linear-gradient(135deg, #6b7280 0%, #4b5563 100%)' }}>
                                    <div className="card-body p-3 text-white">
                                        <p className="m-0 opacity-75 small">Turnos Cerrados</p>
                                        <h4 className="m-0 fw-bold">{stats.turnosCerrados}</h4>
                                        <div className="position-absolute top-0 end-0 p-3 opacity-25"><FaLock size={30}/></div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Tabla de turnos */}
                        <div className="card border-0 shadow-sm" style={{ borderRadius: '16px' }}>
                            <div className="card-header bg-white border-0 p-4 d-flex justify-content-between align-items-center flex-wrap gap-3">
                                <h5 className="m-0 fw-bold text-dark"><FaCashRegister className="me-2 text-info"/> Turnos Registrados</h5>

                                <div className="btn-group shadow-sm">
                                    <button className={`btn btn-sm ${filtroEstado==='todos'?'btn-info text-white':'btn-outline-info'}`} onClick={()=>setFiltroEstado('todos')}>Todos</button>
                                    <button className={`btn btn-sm ${filtroEstado==='abiertos'?'btn-info text-white':'btn-outline-info'}`} onClick={()=>setFiltroEstado('abiertos')}>Abiertos</button>
                                    <button className={`btn btn-sm ${filtroEstado==='cerrados'?'btn-info text-white':'btn-outline-info'}`} onClick={()=>setFiltroEstado('cerrados')}>Cerrados</button>
                                </div>
                            </div>

                            <div className="card-body p-0">
                                <div className="table-responsive">
                                    <table className="table table-hover align-middle mb-0">
                                        <thead className="bg-light">
                                            <tr>
                                                <th className="px-4 py-3 text-muted">ID</th>
                                                <th className="text-muted">FECHA APERTURA</th>
                                                <th className="text-muted">ESTADO</th>
                                                <th className="text-muted">CAJERO</th>
                                                <th className="text-end text-muted">VENTAS</th>
                                                <th className="text-center text-muted">ACCIONES</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {turnosFiltrados.slice(0, limite).map(t => (
                                                <tr key={t.id} style={{background: t.estado === 'abierto' ? '#fffbeb' : 'white'}}>
                                                    <td className="px-4 fw-bold text-primary">#{t.id}</td>
                                                    <td>
                                                        <div className="fw-semibold">{formatBoliviaDate(t.fecha_apertura)}</div>
                                                        <small className="text-muted">{formatBoliviaTime(t.fecha_apertura)}</small>
                                                    </td>
                                                    <td>
                                                        <span className={`badge ${t.estado === 'abierto' ? 'bg-success' : 'bg-secondary'} rounded-pill px-3`}>
                                                            {t.estado === 'abierto' ? 'ABIERTO' : 'CERRADO'}
                                                        </span>
                                                    </td>
                                                    <td>
                                                        <div className="d-flex align-items-center gap-2">
                                                            <div className="rounded-circle bg-info text-white d-flex align-items-center justify-content-center" style={{width:30, height:30, fontSize:'0.8rem'}}>
                                                                {(t.usuario || 'S').charAt(0).toUpperCase()}
                                                            </div>
                                                            <span>{t.usuario || 'Sistema'}</span>
                                                        </div>
                                                    </td>
                                                    <td className="text-end fw-bold text-dark">Bs. {parseFloat(t.total_ventas || 0).toFixed(2)}</td>
                                                    <td className="text-center">
                                                        <div className="d-flex justify-content-center gap-2">
                                                            {t.estado === 'abierto' ? (
                                                                <button className="btn btn-sm btn-danger fw-bold" onClick={() => handleCerrarTurno(t)}>
                                                                    <FaLock className="me-1"/> CERRAR
                                                                </button>
                                                            ) : (
                                                                <>
                                                                    {(() => {
                                                                        const fondoCaja = parseFloat(t.monto_inicial || 0);
                                                                        const ventasEfectivo = parseFloat(t.ventas_efectivo || 0);
                                                                        const esperado = fondoCaja + ventasEfectivo;
                                                                        const contado = parseFloat(t.monto_final || 0);
                                                                        const diferencia = contado - esperado;
                                                                        const esFaltante = diferencia < -0.5;

                                                                        return (
                                                                            <>
                                                                                {esFaltante && (
                                                                                    <button className="btn btn-sm btn-warning me-2" onClick={() => handleAjustarFaltante(t, diferencia)}>
                                                                                        <FaDollarSign className="me-1"/> AJUSTAR
                                                                                    </button>
                                                                                )}
                                                                                <button className="btn btn-sm btn-secondary" onClick={() => handleImpresion('reporte-cierre', t.id)}>
                                                                                    <FaPrint className="me-1"/> REPORTE
                                                                                </button>
                                                                                <button className="btn btn-sm btn-info" onClick={() => descargarDetalleTurno(t.id)}>
                                                                                    <FaFileAlt className="me-1"/> DETALLE
                                                                                </button>
                                                                            </>
                                                                        );
                                                                    })()}
                                                                </>
                                                            )}
                                                            <button className="btn btn-sm btn-outline-primary" onClick={() => verVentas(t)}>
                                                                <FaEye className="me-1"/> VENTAS
                                                            </button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))}
                                            {turnosFiltrados.length === 0 && (
                                                <tr><td colSpan="6" className="text-center py-5 text-muted">No se encontraron turnos</td></tr>
                                            )}
                                        </tbody>
                                    </table>
                                    <div className="text-center py-3">
                                        <small className="text-muted d-block mb-2">
                                            Mostrando {Math.min(limite, turnosFiltrados.length)} de {turnosFiltrados.length} turnos de {tituloMes}
                                        </small>
                                        {turnosFiltrados.length > limite && (
                                            <button type="button" className="btn btn-outline-info" style={{ borderRadius: '20px' }} onClick={() => setLimite(limite + 25)}>Ver 25 más</button>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                )}

                {/* TAB VENTAS ELIMINADAS */}
                {tabActual === 'eliminadas' && (
                    <div className="card border-0 shadow-sm" style={{ borderRadius: '16px' }}>
                        <div className="card-header bg-white border-0 p-4">
                            <h5 className="m-0 fw-bold text-dark"><FaHistory className="me-2 text-danger"/> Historial de Ventas Eliminadas</h5>
                        </div>
                        <div className="card-body p-0">
                            <div className="table-responsive">
                                <table className="table table-hover align-middle mb-0">
                                    <thead className="bg-light">
                                        <tr>
                                            <th className="px-4 py-3">VENTA ID</th>
                                            <th>TURNO</th>
                                            <th>CLIENTE</th>
                                            <th className="text-end">TOTAL</th>
                                            <th>MÉTODO</th>
                                            <th>ELIMINADO POR</th>
                                            <th>FECHA ELIMINACIÓN</th>
                                            <th>MOTIVO</th>
                                            <th>ESTADO</th>
                                            <th className="text-center">ACCIÓN</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {ventasEliminadas.length === 0 && (
                                            <tr>
                                                <td colSpan="10" className="text-center py-5 text-muted">
                                                    <FaHistory size={40} className="mb-3 opacity-25"/>
                                                    <div>No hay ventas eliminadas</div>
                                                </td>
                                            </tr>
                                        )}
                                        {ventasEliminadas.map(ve => (
                                            <tr key={ve.id} style={{background: ve.restaurada ? '#d1fae5' : 'white'}}>
                                                <td className="px-4 fw-bold text-danger">#{ve.venta_id}</td>
                                                <td>Turno #{ve.turno_id}</td>
                                                <td>{ve.cliente_nombre || 'Público General'}</td>
                                                <td className="text-end fw-bold">Bs. {parseFloat(ve.total).toFixed(2)}</td>
                                                <td>
                                                    <span className="badge bg-secondary rounded-pill text-uppercase">
                                                        {ve.metodo_pago}
                                                    </span>
                                                </td>
                                                <td>
                                                    <small>{ve.usuario_elimina_nombre}</small>
                                                </td>
                                                <td>
                                                    <small className="text-muted">{formatBoliviaDateTime(ve.fecha_eliminacion)}</small>
                                                </td>
                                                <td>
                                                    <small className="text-muted">{ve.motivo_eliminacion || '-'}</small>
                                                </td>
                                                <td>
                                                    {ve.restaurada ? (
                                                        <div>
                                                            <span className="badge bg-success mb-1">✓ RESTAURADA</span>
                                                            <div className="small text-muted">
                                                                {formatBoliviaDateTime(ve.fecha_restauracion)}
                                                            </div>
                                                            <div className="small text-muted">
                                                                por {ve.usuario_restaura_nombre}
                                                            </div>
                                                        </div>
                                                    ) : (
                                                        <span className="badge bg-danger">ELIMINADA</span>
                                                    )}
                                                </td>
                                                <td className="text-center">
                                                    {!ve.restaurada && (
                                                        <button 
                                                            className="btn btn-sm btn-success"
                                                            onClick={() => handleRestaurarVenta(ve)}
                                                        >
                                                            <FaUndo className="me-1"/> Restaurar
                                                        </button>
                                                    )}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                )}
            </div>

            {/* Modal Detalle de Ventas */}
            {showModal && turnoSeleccionado && (
                <div className="modal d-block" style={{ backgroundColor: 'rgba(0,0,0,0.6)', backdropFilter: 'blur(4px)' }}>
                    <div className="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
                        <div className="modal-content border-0 shadow-lg" style={{ borderRadius: '20px', overflow: 'hidden' }}>
                            <div className="modal-header text-white" style={{ background: 'linear-gradient(135deg, #06b6d4 0%, #0891b2 100%)' }}>
                                <div>
                                    <h5 className="m-0 fw-bold"><FaReceipt className="me-2"/> Ventas del Turno #{turnoSeleccionado.id}</h5>
                                    <small className="opacity-75">Cajero: {turnoSeleccionado.usuario}</small>
                                </div>
                                <button className="btn-close btn-close-white" onClick={() => setShowModal(false)}></button>
                            </div>
                            <div className="modal-body p-0">
                                <div className="table-responsive">
                                    <table className="table table-hover align-middle mb-0">
                                        <thead className="bg-light">
                                            <tr>
                                                <th className="px-4 py-3">HORA</th>
                                                <th>CLIENTE</th>
                                                <th>MÉTODO</th>
                                                <th>FACTURA</th>
                                                <th>PRODUCTOS</th>
                                                <th className="text-end">TOTAL</th>
                                                <th className="text-center">OPCIONES</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {ventasTurno.map(v => (
                                                <tr key={v.id}>
                                                    <td className="px-4 text-muted"><FaClock className="me-2"/>{formatBoliviaTime(v.fecha)}</td>
                                                    <td>{v.cliente_nombre || 'Público General'}</td>
                                                    <td>
                                                        <span className={`badge ${v.metodo_pago.includes('efectivo') ? 'bg-success' : 'bg-primary'} rounded-pill text-uppercase`}>
                                                            {v.metodo_pago}
                                                        </span>
                                                        {!String(v.metodo_pago || '').toLowerCase().includes('pedidosya') && (
                                                            <button type="button" className="btn btn-sm btn-link p-0 ms-2" title="Cambiar método de pago" onClick={() => abrirMetodo(v)}>✏️</button>
                                                        )}
                                                    </td>
                                                    <td>
                                                        {v.factura_razon_social ? (
                                                            <div className="small">
                                                                <div className="fw-bold text-primary">{v.factura_razon_social}</div>
                                                                <div className="text-muted">NIT: {v.factura_nit}</div>
                                                            </div>
                                                        ) : (
                                                            <span className="text-muted small">-</span>
                                                        )}
                                                    </td>
                                                    <td>
                                                        <div className="small">
                                                            {v.productos && v.productos.length > 0 ? (
                                                                v.productos.map((p, idx) => (
                                                                    <div key={idx} className="text-muted">
                                                                        {p.cantidad}x {p.producto_nombre}
                                                                    </div>
                                                                ))
                                                            ) : (
                                                                <span className="text-muted">Sin productos</span>
                                                            )}
                                                        </div>
                                                    </td>
                                                    <td className="text-end fw-bold">Bs. {parseFloat(v.total).toFixed(2)}</td>
                                                    <td className="text-center">
                                                        <button className="btn btn-sm btn-outline-secondary" onClick={() => handleImpresion('recibo', v.id)}>
                                                            <FaPrint/> Recibo
                                                        </button>
                                                        <button className="btn btn-sm btn-outline-warning mx-2" onClick={() => handleImpresion('comanda', v.id)}>
                                                            <FaUtensils/> Comanda
                                                        </button>
                                                        <button
                                                            className="btn btn-sm btn-outline-primary mx-2"
                                                            onClick={() => handleEditarVenta(v)}
                                                            title="Editar ingredientes"
                                                        >
                                                            <FaFileAlt/> Editar
                                                        </button>
                                                        <button
                                                            className="btn btn-sm btn-outline-danger"
                                                            onClick={() => handleEliminarVenta(v)}
                                                            title="Eliminar venta"
                                                        >
                                                            <FaTrash/> Eliminar
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))}
                                            {ventasTurno.length === 0 && (
                                                <tr><td colSpan="7" className="text-center py-4 text-muted">No hubo ventas en este turno</td></tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div className="modal-footer bg-light">
                                <button className="btn btn-secondary px-4 rounded-pill" onClick={() => setShowModal(false)}>Cerrar</button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Modal Eliminar con PIN */}
            {showModalEliminar && ventaAEliminar && (
                <div className="modal d-block" style={{ backgroundColor: 'rgba(0,0,0,0.7)', backdropFilter: 'blur(4px)' }}>
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content border-0 shadow-lg" style={{ borderRadius: '20px' }}>
                            <div className="modal-header bg-danger text-white">
                                <h5 className="m-0 fw-bold"><FaTrash className="me-2"/> Eliminar Venta #{ventaAEliminar.id}</h5>
                                <button className="btn-close btn-close-white" onClick={() => setShowModalEliminar(false)}></button>
                            </div>
                            <div className="modal-body p-4">
                                <div className="alert alert-warning">
                                    <strong>⚠️ Atención:</strong> Esta acción moverá la venta al historial de eliminadas. Podrá ser restaurada posteriormente.
                                </div>

                                <div className="mb-3">
                                    <label className="form-label fw-bold">Cliente:</label>
                                    <p className="mb-0">{ventaAEliminar.cliente_nombre || 'Público General'}</p>
                                </div>

                                <div className="mb-3">
                                    <label className="form-label fw-bold">Total:</label>
                                    <p className="mb-0 text-danger fw-bold">Bs. {parseFloat(ventaAEliminar.total).toFixed(2)}</p>
                                </div>

                                <div className="mb-3">
                                    <label className="form-label fw-bold text-danger">PIN de Seguridad: *</label>
                                    <input 
                                        type="password"
                                        className="form-control form-control-lg"
                                        value={pinEliminar}
                                        onChange={(e) => setPinEliminar(e.target.value)}
                                        placeholder="Ingrese PIN"
                                        autoFocus
                                    />
                                    <small className="text-muted">Ingrese el PIN de seguridad para confirmar</small>
                                </div>

                                <div className="mb-3">
                                    <label className="form-label fw-bold">Motivo (opcional):</label>
                                    <textarea 
                                        className="form-control"
                                        rows="3"
                                        value={motivoEliminar}
                                        onChange={(e) => setMotivoEliminar(e.target.value)}
                                        placeholder="Ej: Comanda duplicada, error en el pedido, etc."
                                    />
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button className="btn btn-secondary" onClick={() => setShowModalEliminar(false)}>
                                    Cancelar
                                </button>
                                <button 
                                    className="btn btn-danger fw-bold"
                                    onClick={confirmarEliminacion}
                                    disabled={!pinEliminar}
                                >
                                    <FaTrash className="me-2"/> Eliminar Venta
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Modal Cambiar Método de Pago */}
            {showModalMetodo && ventaMetodo && (
                <div className="modal d-block" style={{ backgroundColor: 'rgba(0,0,0,0.7)', backdropFilter: 'blur(4px)' }}>
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content border-0 shadow-lg" style={{ borderRadius: '20px' }}>
                            <div className="modal-header bg-info text-white">
                                <h5 className="m-0 fw-bold">💳 Cambiar método de pago · Venta #{ventaMetodo.id}</h5>
                                <button className="btn-close btn-close-white" onClick={() => setShowModalMetodo(false)}></button>
                            </div>
                            <div className="modal-body p-4">
                                <div className="alert alert-light border mb-3">
                                    Total: <strong>Bs. {parseFloat(ventaMetodo.total).toFixed(2)}</strong>
                                    <br />
                                    Método actual: <strong className="text-uppercase">{ventaMetodo.metodo_pago}</strong>
                                </div>

                                <label className="fw-bold small mb-1">Nuevo método *</label>
                                <div className="btn-group w-100 mb-3">
                                    {[{ k: 'efectivo', t: '💵 Efectivo' }, { k: 'qr', t: '📱 QR' }, { k: 'mixto', t: '🔀 Mixto' }].map(o => (
                                        <button
                                            key={o.k}
                                            type="button"
                                            className={`btn ${nuevoMetodo === o.k ? 'btn-info text-white fw-bold' : 'btn-outline-info'}`}
                                            onClick={() => setNuevoMetodo(o.k)}
                                        >
                                            {o.t}
                                        </button>
                                    ))}
                                </div>

                                {nuevoMetodo === 'mixto' && (
                                    <div className="row g-2 mb-3">
                                        <div className="col-6">
                                            <label className="fw-bold small">💵 Efectivo (Bs)</label>
                                            <input
                                                type="number"
                                                step="0.01"
                                                min="0"
                                                className="form-control form-control-lg"
                                                value={montoE}
                                                onChange={(ev) => cambiarMonto('e', ev.target.value)}
                                            />
                                        </div>
                                        <div className="col-6">
                                            <label className="fw-bold small">📱 QR (Bs)</label>
                                            <input
                                                type="number"
                                                step="0.01"
                                                min="0"
                                                className="form-control form-control-lg"
                                                value={montoQ}
                                                onChange={(ev) => cambiarMonto('q', ev.target.value)}
                                            />
                                        </div>
                                        <div className="col-12 small text-muted">Deben sumar Bs. {parseFloat(ventaMetodo.total).toFixed(2)}</div>
                                    </div>
                                )}

                                <div className="alert alert-warning small py-2">
                                    Esto cambia cuánto efectivo se espera en el cierre del turno. Los productos de la venta no se tocan.
                                </div>

                                <label className="fw-bold small text-danger">PIN de seguridad *</label>
                                <input
                                    type="password"
                                    name="pin_metodo_pago"
                                    autoComplete="new-password"
                                    className="form-control form-control-lg"
                                    placeholder="Ingrese PIN"
                                    value={pinMetodo}
                                    onChange={(ev) => setPinMetodo(ev.target.value)}
                                />
                            </div>
                            <div className="modal-footer">
                                <button className="btn btn-secondary" onClick={() => setShowModalMetodo(false)}>Cancelar</button>
                                <button className="btn btn-info text-white fw-bold" onClick={guardarMetodo} disabled={guardandoMetodo}>
                                    {guardandoMetodo ? 'Guardando...' : 'Guardar método'}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Modal Editar Ingredientes */}
            {showModalEditar && ventaEditando && (
                <div className="modal d-block" style={{ backgroundColor: 'rgba(0,0,0,0.7)', backdropFilter: 'blur(4px)' }}>
                    <div className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
                        <div className="modal-content border-0 shadow-lg" style={{ borderRadius: '20px' }}>
                            <div className="modal-header bg-primary text-white">
                                <h5 className="m-0 fw-bold"><FaFileAlt className="me-2"/> Editar Venta #{ventaEditando.id}</h5>
                                <button className="btn-close btn-close-white" onClick={() => setShowModalEditar(false)}></button>
                            </div>
                            <div className="modal-body p-4">
                                {productosEditando.map((p, idx) => {
                                    const esMixta = p._esMixta;
                                    let ingredientesUnificados = [];

                                    if (esMixta) {
                                        const recetaM1 = recetasCache[p._parsed?.m1] || [];
                                        const recetaM2 = recetasCache[p._parsed?.m2] || [];
                                        const map = {};
                                        recetaM1.forEach(ing => {
                                            if (!map[ing.insumo_id]) map[ing.insumo_id] = { ...ing, enM1: false, enM2: false };
                                            map[ing.insumo_id].enM1 = true;
                                        });
                                        recetaM2.forEach(ing => {
                                            if (!map[ing.insumo_id]) map[ing.insumo_id] = { ...ing, enM1: false, enM2: false };
                                            map[ing.insumo_id].enM2 = true;
                                        });
                                        ingredientesUnificados = Object.values(map);
                                    }

                                    const recetaSimple = !esMixta ? (recetasCache[p.producto_nombre] || []) : [];
                                    const excluidosSimple = Array.isArray(p._parsed) ? p._parsed.map(i => parseInt(i)) : [];

                                    return (
                                        <div key={idx} className="mb-4 pb-4 border-bottom">
                                            <h6 className="fw-bold text-primary">{p.cantidad}x {p.producto_nombre}</h6>

                                            {esMixta && (
                                                <div className="mb-2">
                                                    <div className="small text-muted mb-1">- {p._parsed?.m1}</div>
                                                    <div className="small text-muted mb-2">- {p._parsed?.m2}</div>
                                                </div>
                                            )}

                                            <label className="fw-bold small text-primary d-block mb-2">
                                                📋 INGREDIENTES QUE NO QUIERA INCLUIR{esMixta ? ' (UNIFICADOS)' : ''}:
                                            </label>
                                            <div className="alert alert-light border-2 border-primary p-3">
                                                <div className="row g-2">
                                                    {esMixta ? (
                                                        ingredientesUnificados.length > 0 ? ingredientesUnificados.map((ing, i2) => {
                                                            const m1Excl = Array.isArray(p._parsed?.m1_excluidos) ? p._parsed.m1_excluidos.map(x => parseInt(x)) : [];
                                                            const m2Excl = Array.isArray(p._parsed?.m2_excluidos) ? p._parsed.m2_excluidos.map(x => parseInt(x)) : [];
                                                            const excluido = (ing.enM1 && m1Excl.includes(ing.insumo_id)) || (ing.enM2 && m2Excl.includes(ing.insumo_id));
                                                            return (
                                                                <div key={i2} className="col-12">
                                                                    <button
                                                                        onClick={() => toggleIngredienteMixta(idx, ing.insumo_id, ing.enM1, ing.enM2)}
                                                                        className={`btn w-100 py-2 ${excluido ? 'btn-danger' : 'btn-outline-success'}`}
                                                                    >
                                                                        <span className="fw-bold">{ing.nombre_insumo}</span>
                                                                    </button>
                                                                </div>
                                                            );
                                                        }) : <div className="col-12 text-center text-muted"><small>Sin ingredientes</small></div>
                                                    ) : (
                                                        recetaSimple.length > 0 ? recetaSimple.map((ing, i2) => {
                                                            const excluido = excluidosSimple.includes(ing.insumo_id);
                                                            return (
                                                                <div key={i2} className="col-12">
                                                                    <button
                                                                        onClick={() => toggleIngredienteSimple(idx, ing.insumo_id)}
                                                                        className={`btn w-100 py-2 ${excluido ? 'btn-danger' : 'btn-outline-success'}`}
                                                                    >
                                                                        <span className="fw-bold">{ing.nombre_insumo}</span>
                                                                    </button>
                                                                </div>
                                                            );
                                                        }) : <div className="col-12 text-center text-muted"><small>Este producto no tiene ingredientes configurables</small></div>
                                                    )}
                                                </div>
                                            </div>

                                            {(() => {
                                                let resumen = [];
                                                if (esMixta) {
                                                    const m1Excl = Array.isArray(p._parsed?.m1_excluidos) ? p._parsed.m1_excluidos.map(x => parseInt(x)) : [];
                                                    const m2Excl = Array.isArray(p._parsed?.m2_excluidos) ? p._parsed.m2_excluidos.map(x => parseInt(x)) : [];
                                                    const totales = {};
                                                    ingredientesUnificados.forEach(ing => {
                                                        let cantidad = 0;
                                                        if (ing.enM1 && !m1Excl.includes(ing.insumo_id)) cantidad += 0.5;
                                                        if (ing.enM2 && !m2Excl.includes(ing.insumo_id)) cantidad += 0.5;
                                                        cantidad = cantidad * p.cantidad;
                                                        if (cantidad > 0) {
                                                            totales[ing.nombre_insumo] = (totales[ing.nombre_insumo] || 0) + cantidad;
                                                        }
                                                    });
                                                    resumen = Object.entries(totales).map(([nombre, cant]) => `${cant % 1 === 0 ? cant : cant.toFixed(2)} ${nombre}`);
                                                } else {
                                                    resumen = recetaSimple
                                                        .filter(ing => !excluidosSimple.includes(ing.insumo_id))
                                                        .map(ing => {
                                                            const cant = ing.cantidad_requerida * p.cantidad;
                                                            return `${cant % 1 === 0 ? cant : cant.toFixed(2)} ${ing.nombre_insumo}`;
                                                        });
                                                }
                                                return (
                                                    <div className="alert alert-info py-2 px-3 small mb-2">
                                                        {resumen.length > 0
                                                            ? <>✅ Este producto está descontando: <strong>{resumen.join(', ')}</strong></>
                                                            : <>ℹ️ Este producto no descontará ningún ingrediente</>
                                                        }
                                                    </div>
                                                );
                                            })()}

                                            <label className="fw-bold small mt-2 d-block">OBSERVACIONES:</label>
                                            <textarea
                                                className="form-control"
                                                rows="2"
                                                value={p.observacion || ''}
                                                onChange={(e) => actualizarObservacionEditando(idx, e.target.value)}
                                            />
                                        </div>
                                    );
                                })}
                            </div>
                            <div className="modal-footer">
                                <button className="btn btn-secondary" onClick={() => setShowModalEditar(false)}>
                                    Cancelar
                                </button>
                                <button className="btn btn-primary fw-bold" onClick={guardarEdicion}>
                                    <FaCheckCircle className="me-2"/> Guardar Cambios
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
